import React, { Fragment } from 'react';
import AddServiceCard from 'Components/Front/Booking/AddServiceCard';
import { num } from 'Shared/utilities';
const NO_ERRORS = {};
export default function AddBookingServices({
  ...props
}) {
  const hours_count = num(props.hours_count, 0);
  const people = num(props.people, 0);
  const start = props.start;
  const end = props.end;
  const services = (props.categories || []).map(function (category, i) {
    // mobile & tablet
    const has__widget = window.innerWidth > 1200 && i === 0;
    const modifiers = ['front'].concat(has__widget ? ['with-widget'] : []);
    const services = (category.__services || []).map(function (service, i) {
      const output = /*#__PURE__*/React.createElement(AddServiceCard, {
        key: service.id,
        service: service,
        status: NO_ERRORS,
        value: props.selected?.[service.id] || '',
        people: people,
        start: start,
        end: end,
        bemit: modifiers,
        category: category,
        "hide-category": i > 0,
        hours_count: hours_count,
        onChange: props.onChange
      });
      return output;
    });
    const output = /*#__PURE__*/React.createElement(Fragment, {
      key: category.value
    }, services);
    return output;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "add-booking-services"
  }, services);
}
